// VERA-873: deep-link a company out to external tools.
// Each entry is a base URL + the record id stored on the company row
// (apollo_id / stripe_customer_id / shopify_customer_id).
// If a vendor changes its URL scheme, adjust the base here only.
export const EXTERNAL_LINK_BASES = {
  apollo: 'https://app.apollo.io/#/organizations/',
  stripeCustomer: 'https://dashboard.stripe.com/customers/',
  shopifyCustomer: 'https://admin.shopify.com/customers/',
} as const

/** Build `base + id`, or null when the id is missing (caller hides the affordance). */
export const buildExternalLink = (
  base: string,
  id?: string | number | null,
): string | null => (id ? `${base}${encodeURIComponent(String(id))}` : null)

/** Open an external link in a new tab (no-op when null). */
export const openExternalLink = (url: string | null): void => {
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}
